import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('admin_token');

    if (!token) {
        // Redirect to login if not authenticated
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
